export const formatUrlWithProtocol = (url: string) => {
  let formattedUrl = url;
  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    formattedUrl = `https://${url}`;
  }
  return formattedUrl;
};

export const validURL = (str: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return !!pattern.test(str);
};
